import { render } from "./Features.vue?vue&type=template&id=ace481c2&scoped=true"
import script from "./Features.vue?vue&type=script&lang=js"
export * from "./Features.vue?vue&type=script&lang=js"

import "./Features.vue?vue&type=style&index=0&id=ace481c2&lang=scss&scoped=true"

import exportComponent from "/home/maud/code/tutuyoutoo-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ace481c2"]])

export default __exports__